export enum Action {
  screenDisplayed = 'ScreenDisplayed',
  controlButtonClicked = 'ControlButtonClicked'
}

export type EventData = {
  version: string;
  activity: string;
  screenPath: string;
  action: Action;
  screenName: string;
  controlName?: string;
} & CustomEventData;

export type CustomEventData = {
  screenMode?: string;
  controlDetail?: string;
  actionAuxParams?: string;
};

export enum ScreenAction {
  REDIRECT_TO_HP_ID,
  BACK_FROM_HP_ID,
  REDIRECT_TO_TENANT_SELECTOR,
  BACK_FROM_TENANT_SELECTOR,
  REDIRECT_TO_SAFETY_NET_SCREEN_ERROR,
  UNRECOVERABLE_SCREEN_ERROR,
  UNRECOVERABLE_SCREEN_ERROR_ACKNOWLEDGE,
  COMPLETED
}

export enum BackFromHpIdType {
  SIGNED_IN_NOT_PREVIOUSLY_ONBOARDED = 'SignedInNotPreviouslyOnboarded',
  SIGNED_IN_PREVIOUSLY_ONBOARDED = 'SignedInPreviouslyOnboarded',
  NOT_SIGNED_IN = 'NotSignedIn'
}

export type EventAction = { type: ScreenAction; payload?: CustomEventData };
